import { SquareArrowOutUpRight } from "lucide-react";

import { Link } from "@tanstack/react-router";

type Props = {
  href: string;
};

export const LinkCell = ({ href }: Props) => {
  return (
    <Link to={href} rel="noopener noreferrer" target="_blank">
      <SquareArrowOutUpRight size={14} />
    </Link>
  );
};
